import type { IconAsset } from '../Icon.types';

const code = (
  <path
    d='M10.865,19.267,9.579,18.1C5.014,13.957,2,11.226,2,7.876A4.828,4.828,0,0,1,6.876,3a5.308,5.308,0,0,1,3.989,1.853A5.308,5.308,0,0,1,14.854,3a4.828,4.828,0,0,1,4.876,4.876c0,3.351-3.014,6.081-7.579,10.23Z'
    fill='currentColor'
    transform='translate(1.135 0.867)'
  />
);

export const heart: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
